import { useEffect } from 'react'
import { useLocalStorage } from 'react-use'

import { Account } from '@modules-deprecated/app/accounts/types'
import { useUserOrganization } from '@modules-deprecated/app/organization'

import { LocalStorageKeys } from '../../../enums/localStorageKeys'
import { isPartnerAccount } from '../../../utils/accountTypeCheckers'

export const useConnectBankPrompt = (selectedAccount?: Account) => {
  const { organization } = useUserOrganization()
  const organizationId = organization?.id

  const localStorageKey = `${LocalStorageKeys.HideConnectBankOverlay}-${organizationId}-${selectedAccount?.id}`

  const [isPromptHidden, setIsPromptHidden] = useLocalStorage<boolean>(localStorageKey, undefined)

  useEffect(() => {
    if (!selectedAccount || !isPartnerAccount(selectedAccount)) {
      return
    }
    setIsPromptHidden(true)
  }, [selectedAccount, setIsPromptHidden])

  return { isPromptHidden, setIsPromptHidden }
}
